import ChangeRecieveRefundableFeeMethod from './ChangeRecieveRefundableFeeMethod';

export default ChangeRecieveRefundableFeeMethod;
